import { Injectable } from '@angular/core';

export interface AppConfigResponse {
    paymentsPublicKey?: string | null;
    recaptchaV3SiteKey?: string | null;
}

@Injectable({
    providedIn: 'root',
})
export class RuntimeConfigService {
    private _config: AppConfigResponse = {};

    set(config: AppConfigResponse | null | undefined): void {
        this._config = config ?? {};
    }

    getRecaptchaV3SiteKey(): string | null {
        return this._config.recaptchaV3SiteKey ?? null;
    }

    getPaymentsPublicKey(): string | null {
        return this._config.paymentsPublicKey ?? null;
    }
}
